import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * CustomInventarioFisico
 **/
class CustomInventarioFisico extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.gridOptionsComponentes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedPrincipal = this.onSelectionChangedPrincipal.bind(this);
        this.gridOptionsComponentes['onSelectionChanged'] = this.onSelectionChangedPrincipal;


        this.gridOptionsSegundo = Object.assign({}, this.gridOptions);
        this.gridOptionsSegundo['rowData'] = [];
        this.onSelectionChangedSegundo = this.onSelectionChangedSegundo.bind(this);
        this.gridOptionsSegundo['onSelectionChanged'] = this.onSelectionChangedSegundo;

        this.gridOptionsDetallado = Object.assign({}, this.gridOptions);
        this.gridOptionsDetallado['rowData'] = [];
        this.onSelectionChangedDetallado = this.onSelectionChangedDetallado.bind(this);
        this.gridOptionsDetallado['onSelectionChanged'] = this.onSelectionChangedDetallado;

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);

        this.opcionGernarConsecutivo = this.opcionGernarConsecutivo.bind(this);
        this.generarConsecutivo = this.generarConsecutivo.bind(this);
        this.sucessgenerarConsecutivo = this.sucessgenerarConsecutivo.bind(this);

        this.cerrarConsecutivoConteo = this.cerrarConsecutivoConteo.bind(this);
        this.asentarConAjuste = this.asentarConAjuste.bind(this);
        this.sucessAsentarConAjuste = this.sucessAsentarConAjuste.bind(this);
        this.cerrarDiferencias = this.cerrarDiferencias.bind(this);
        this.sucessCerrarDiferencias = this.sucessCerrarDiferencias.bind(this);
        this.reiniciarDiferencias = this.reiniciarDiferencias.bind(this);
        this.sucessreiniciarDiferencias = this.sucessreiniciarDiferencias.bind(this);
        this.sucessgenerarDiferencias = this.sucessgenerarDiferencias.bind(this);
        this.traerArticulosUbicaciones = this.traerArticulosUbicaciones.bind(this);
        this.successTraerArticulosUbicaciones = this.successTraerArticulosUbicaciones.bind(this);
        this.traerConsecutivoDetallado = this.traerConsecutivoDetallado.bind(this);
        this.successTraerConsecutivoDetallado = this.successTraerConsecutivoDetallado.bind(this);
        this.traerDatos = this.traerDatos.bind(this);
        this.succesTraerDatos = this.succesTraerDatos.bind(this);
        this.inventarioFisico = this.inventarioFisico.bind(this);


        //imprimir

        this.mostrarMensajeEmailFallo = this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado = this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada = [];
        this.fila_seleccionada_detallado = [];
    }

    initForm() {
        console.log('Formulario CustomInventarioFisico,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();

        if (this.props.data[0].opcion_sub_seccion === 1) {//generar cosnecutivo
            this.getField('opcion_form').setValue('Generar Consecutivo de Conteo');
            this.opcionGernarConsecutivo();
        } else if (this.props.data[0].opcion_sub_seccion === 2) { //cerrar consecutivo
            this.getField('opcion_form').setValue('Cerrar Consecutivo de Conteo');
            this.cerrarConsecutivoConteo();
        } else if (this.props.data[0].opcion_sub_seccion === 3) { //inventario físico por ubicacion
            this.getField('opcion_form').setValue('Inventario Físico por Ubicación');
            this.inventarioFisico();
        }

    }

    //primera opcion--->
    opcionGernarConsecutivo() {
        this.getField('ubicacion_a_contar').setVisible(true);
        this.getField('bt_crear').setVisible(true);
        this.getField('numero_ubicacion').setVisible(true);

        this.getField('bt_crear').setClick(() => {
            this.generarConsecutivo();
        });

        this.getField('ubicacion_a_contar').setOnChange(() => {
            this.getField('numero_ubicacion').setValue('');
        });

    }

    generarConsecutivo() {
        this.getField('ubicacion_a_contar').setError(false, '');
        if (this.getField('ubicacion_a_contar').valid()) {
            this.mostrarMensajeGenerando();
            let datos = {
                datos: {
                    sucursal_ingreso: this.sucursal_ingreso,
                    ubicacion_a_contar: this.getField('ubicacion_a_contar').getValue(),
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'inve-wmsinventariofisico', operacion: 'crearconsecutivoconteo', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.sucessgenerarConsecutivo,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        } else {
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    sucessgenerarConsecutivo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            } if (data.data.mensaje_mostrar_2 !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar_2);
                this.getField('numero_ubicacion').setValue(data.data.consecutivo+'');
            } else {
                //no debería entrar acá
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    //segunda opcion
    cerrarConsecutivoConteo() {
        this.traerArticulosUbicaciones();

        this.getField('bt_consultar_consecutivo').setClick(() => {
            this.generarDiferencias();
        });

        this.getField('bt_reiniciar').setClick(() => {
            if (this.fila_seleccionada_detallado.length > 0) {
                this.reiniciarDiferencias();
            } else {
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro de la segunda tabla.', "error");
            }
        });

        this.getField('bt_cerrar_sin_ajuste').setClick(() => {
            if (this.fila_seleccionada_detallado.length > 0) {
                this.cerrarDiferencias();
            } else {
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro de la segunda tabla.', "error");
            }
        });

        this.getField('bt_asentar_ajuste').setClick(() => {
            if (this.fila_seleccionada_detallado.length > 0) {
                this.asentarConAjuste();
            } else {
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro de la segunda tabla.', "error");
            }
        });

    }

    asentarConAjuste() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                numero: this.fila_seleccionada_detallado[0].consecutivo+'',
                ubicacion: this.fila_seleccionada_detallado[0].ubicacion,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-wmsinventariofisico', operacion: 'asentarconajuste', operacion_tipo: 'modificar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: datos,
                success: this.sucessAsentarConAjuste,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    sucessAsentarConAjuste(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {

            this.traerArticulosUbicaciones();
            this.getField('bt_reiniciar').setVisible(false);
            this.getField('bt_cerrar_sin_ajuste').setVisible(false);
            this.getField('bt_asentar_ajuste').setVisible(false);
            this.getField('rejilla_detallada').toggle(false);
            if (data.data.mensaje !== undefined)
                this.mostrarMensajeAdicional(data.data.mensaje);
            if(data.data.errores!==undefined){ // puede no haber traido el consecutivo
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }


    cerrarDiferencias() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                numero: this.fila_seleccionada_detallado[0].consecutivo+'',
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-wmsinventariofisico', operacion: 'cerrardiferenciar', operacion_tipo: 'modificar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: datos,
                success: this.sucessCerrarDiferencias,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    sucessCerrarDiferencias(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {

            this.traerArticulosUbicaciones();
            this.getField('bt_reiniciar').setVisible(false);
            this.getField('bt_cerrar_sin_ajuste').setVisible(false);
            this.getField('bt_asentar_ajuste').setVisible(false);
            this.getField('rejilla_detallada').toggle(false);
            if (data.data.mensaje !== undefined)
                this.mostrarMensajeAdicional(data.data.mensaje);
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }


    reiniciarDiferencias() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                numero: this.fila_seleccionada_detallado[0].consecutivo+'',
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-wmsinventariofisico', operacion: 'reiniciardiferencias', operacion_tipo: 'modificar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: datos,
                success: this.sucessreiniciarDiferencias,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    sucessreiniciarDiferencias(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {

            this.traerArticulosUbicaciones();
            this.getField('bt_reiniciar').setVisible(false);
            this.getField('bt_cerrar_sin_ajuste').setVisible(false);
            this.getField('bt_asentar_ajuste').setVisible(false);
            this.getField('rejilla_detallada').toggle(false);
            if (data.data.mensaje !== undefined)
                this.mostrarMensajeAdicional(data.data.mensaje);
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    onSelectionChangedSegundo() {
        this.fila_seleccionada = this.gridOptionsSegundo.api.getSelectedRows();
    }

    generarDiferencias() {
        if (this.fila_seleccionada.length > 0) {
            this.getField('bt_reiniciar').setVisible(false);
            this.getField('bt_cerrar_sin_ajuste').setVisible(false);
            this.getField('bt_asentar_ajuste').setVisible(false);
            this.getField('rejilla_detallada').toggle(false);

            this.mostrarMensajeGenerando();
            let datos = {
                datos: {
                    sucursal_ingreso: this.sucursal_ingreso,
                    numero: this.fila_seleccionada[0].numero+'',
                    ubicacion: this.fila_seleccionada[0].ubicacion,
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'inve-wmsinventariofisico', operacion: 'calculardiferencias', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.sucessgenerarDiferencias,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        } else {
            this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro de la tabla.', "error");
        }
    }

    sucessgenerarDiferencias(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.traerConsecutivoDetallado();
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    traerArticulosUbicaciones() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
            }
        }

        this.getField("rejilla_consecutivos").setTipoServicioOperacion('inve-wmsinventariofisico-1_diferencias');//_pag
        this.getField("rejilla_consecutivos").sendRequest(this.successTraerArticulosUbicaciones, datos);
    }


    successTraerArticulosUbicaciones(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('rejilla_consecutivos').toggle(true);
            this.gridOptionsSegundo['rowData'] = data.data;
            let configCell = new Map();

            configCell.set('id', { cellRenderer: (props) => { return "" + props.data.id }, hide: true });

            this.getField('rejilla_consecutivos').initData(this.gridOptionsSegundo, configCell);
            this.getField('bt_consultar_consecutivo').setVisible(true);
        }
        else {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);

                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
    }



    traerConsecutivoDetallado() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
            }
        }

        this.getField("rejilla_detallada").setTipoServicioOperacion('inve-wmsinventariofisico-1_consecutivodetallado');//_pag
        this.getField("rejilla_detallada").sendRequest(this.successTraerConsecutivoDetallado, datos);
    }


    successTraerConsecutivoDetallado(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('rejilla_detallada').toggle(true);
            this.gridOptionsDetallado['rowData'] = data.data;
            let configCell = new Map();

            configCell.set('xconteo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.xconteo) }, cellStyle: { textAlign: "right" } });
            configCell.set('xsaldo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.xsaldo) }, cellStyle: { textAlign: "right" } });
            configCell.set('xdiferencia', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.xdiferencia) }, cellStyle: { textAlign: "right" } });
            configCell.set('xveces', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.xveces) }, cellStyle: { textAlign: "right" } });

            this.getField('rejilla_detallada').initData(this.gridOptionsDetallado, configCell);

            this.getField('bt_reiniciar').setVisible(true);
            this.getField('bt_cerrar_sin_ajuste').setVisible(true);
            this.getField('bt_asentar_ajuste').setVisible(true);

        }
        else {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);

                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
    }

    onSelectionChangedDetallado() {
        this.fila_seleccionada_detallado = this.gridOptionsDetallado.api.getSelectedRows();
    }


    //tercera opcion--->

    inventarioFisico() {
        this.getField('select_ubicaciones').setVisible(true);
        this.getField('codigo_articulo').setVisible(true);
        this.getField('nombre_articulo').setVisible(true);
        this.getField('bt_consultar_referencia').setVisible(true);

        this.getField('bt_consultar_referencia').setClick(() => {
            this.traerDatos();
        });

        this.getField('nombre_articulo').setOnChange(() => {
            this.getField('nombre_articulo').setError(false,'');
            this.getField('rejilla').toggle(false);
        });

    }

    traerDatos() {
        this.getField('select_ubicaciones').setError(false, '');
        this.getField('codigo_articulo').setError(false, '');
        this.getField('nombre_articulo').setError(false, '');
        if (this.getField('select_ubicaciones').valid() && this.getField('codigo_articulo').valid()
            && this.getField('nombre_articulo').valid()) {
            this.mostrarMensajeGenerando();
            let datos = {
                datos: {
                    select_ubicaciones: this.getField('select_ubicaciones').getValue(),
                    codigo_articulo: this.getField('codigo_articulo').getValue(),
                    sucursal_ingreso: this.sucursal_ingreso,
                }
            }

            this.getField("rejilla").setTipoServicioOperacion('inve-wmsinventariofisico-1_saldos');//_pag
            this.getField("rejilla").sendRequest(this.succesTraerDatos, datos);
        } else {
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }


    succesTraerDatos(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('rejilla').toggle(true);
            this.gridOptionsComponentes['rowData'] = data.data;

            let configCell = new Map();
            configCell.set('cantidad', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: { textAlign: "right" } });
            configCell.set('saldo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: { textAlign: "right" } });

            this.getField('rejilla').initData(this.gridOptionsComponentes, configCell);
        }
        else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);

                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
    }


    onSelectionChangedPrincipal() {

    }


    traerPropiedades() {
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-saldosporubicacion', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);

        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
            this.wms_nuevo = data.data.wms_nuevo;
            this.trasladar = data.data.trasladar;
        } else if (data.estado_p === 404) {

            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }


    //Funciones comunes ---------------------------------->

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


}
FormJaivana.addController("inve-wmsinventariofisico", CustomInventarioFisico);
export default CustomInventarioFisico